import { gql } from '@apollo/client'

export const CREATE_CATEGORY = gql`
  mutation createCategory($input: CreateCategoryInput!) {
    data: createCategory(input: $input) {
      id
    }
  }
`
